module.exports = __webpack_public_path__ + "img/Piece-18-4.f95b67aa.png";